import {
  createFlat,
  createFlatPlanning,
  deletePlanning,
  getFlats,
  getFlatsByApartment,
  updateFlat,
  getFlatPlannings,
  getSingleFlat,
  editFlatPlanning,
  attachFlatsToPlannning,
  getFlatCharacteristic,
  getFlatPlanningsByApartment,
  createFlatCalculation,
  updateFlatCalculation,
  deleteFlatCalculation,
  getFlatCOFile,
  createFlatRegister,
  getFlatPercentages,
  updatePricePerKv,
} from '@/api/flats'

export default {
  FETCH_FLATS({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      getFlats(data).then(response => {
        commit('SET_FLATS', response.data)
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  FETCH_ONE_FLAT({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      getSingleFlat(data).then(response => {
        commit('SET_ONE_FLAT', response.data)
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  ADD_FLAT(a, data) {
    return createFlat(data)
  },
  EDIT_FLAT(a, data) {
    return updateFlat(data)
  },

  CREATE_FLAT_PLANNING(a, data) {
    return createFlatPlanning(data)
  },

  EDIT_FLAT_PLANNING(a, data) {
    return editFlatPlanning(data)
  },

  DELETE_FLAT_PLANNING(a, data) {
    return deletePlanning(data)
  },

  ATTACH_FLATS_TO_PLANNING(a, data) {
    return attachFlatsToPlannning(data)
  },

  FETCH_FLATS_PLANNINGS({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      getFlatPlannings(data).then(response => {
        commit('SET_FLATS_PLANNINGS', response.data)
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  FETCH_FLATS_PLANNINGS_BY_APARTMENT({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      getFlatPlanningsByApartment(data).then(response => {
        commit('SET_FLATS_PLANNINGS', response.data)
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  FETCH_FLATS_BY_APARTMENT({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      getFlatsByApartment(data).then(response => {
        commit('SET_FLATS', response.data)
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  FETCH_FLAT_CHARACTERISTIC({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      getFlatCharacteristic(data).then(response => {
        commit('SET_FLAT_CHARACTERISTIC', response.data)
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  ADD_FLAT_CALCULATION(_, data) {
    return createFlatCalculation(data)
  },

  UPDATE_FLAT_CALCULATION(_, data) {
    return updateFlatCalculation(data)
  },

  DELETE_FLAT_CALCULATION(_, data) {
    return deleteFlatCalculation(data)
  },
  GET_FLAT_CO_FILE(_, data) {
    return getFlatCOFile(data)
  },
  CREATE_FLAT_REGISTER(_, data) {
    return createFlatRegister(data)
  },

  FETCH_FLAT_PERCENTAGES({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      getFlatPercentages(data).then(response => {
        commit('SET_FLAT_PERCENTAGES', response.data)
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  UPDATE_FLAT_PRICE_PER_SQUARE(_, data) {
    return updatePricePerKv(data)
  },
}